import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { GameService } from 'src/app/services/game.service';

@Component({
  selector: 'app-successful-gamecode-submission',
  templateUrl: './successful-gamecode-submission.component.html',
  styleUrls: ['./successful-gamecode-submission.component.scss']
})
export class SuccessfulGamecodeSubmissionComponent implements OnInit {

  game: any;
  joiningAsSpectator: boolean = false;
  playerId: string = '';
  err = "";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private gameService: GameService,
  private router: Router, 
  private dialogRef: MatDialogRef<SuccessfulGamecodeSubmissionComponent>,
  private auth: AuthService) { }

  ngOnInit(): void {
    this.game = this.data.game;
    const player = this.auth.getPlayer();
    if(player){
      this.playerId = player.playerid
    }
    
  }

  joinGame(){
    this.joiningAsSpectator = true;
    return this.gameService.addNewPlayer(this.game.gameid, localStorage.getItem('kt_client_id'), this.playerId)
    .subscribe((response: any) => {
      this.joiningAsSpectator = false;
      if(response?.success){
        this.router.navigate(['game', this.game.gameid]);
        this.dialogRef.close();
      }
    }, error => {
      this.joiningAsSpectator = false;
      this.err = "Something went wrong...";
      console.log(error);
    })
  }

}
